import type { BodyRequest } from '@pba/react-utils';
import { type ApiClientResponse, mediaModuleClient, mediaRoutes } from 'common/services';

type MediaExportRequestData = {
  ids: string[];
};

export const mediaExport = async ({ body }: BodyRequest<MediaExportRequestData>): Promise<ApiClientResponse<Blob>> =>
  mediaModuleClient.post<Blob, ApiClientResponse<Blob>>(mediaRoutes.export, body, {
    responseType: 'blob',
  });
